import { render, staticRenderFns } from "./ItemSku.vue?vue&type=template&id=3c195554&scoped=true&"
import script from "./ItemSku.vue?vue&type=script&lang=js&"
export * from "./ItemSku.vue?vue&type=script&lang=js&"
import style0 from "./ItemSku.vue?vue&type=style&index=0&id=3c195554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c195554",
  null
  
)

export default component.exports